__turbopack_context__.v({
  "button": "style-module-scss-module__ydrj-W__button",
  "button-container": "style-module-scss-module__ydrj-W__button-container",
  "card": "style-module-scss-module__ydrj-W__card",
  "component": "style-module-scss-module__ydrj-W__component",
  "image": "style-module-scss-module__ydrj-W__image",
  "right": "style-module-scss-module__ydrj-W__right",
  "text": "style-module-scss-module__ydrj-W__text",
});
